// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  name: __t.string(),
  hwaccel: __t.string(),
  hostname: __t.string(),
  version: __t.string(),
  online: __t.bool(),
  disabled: __t.bool(),
  busy: __t.bool(),
  lastSeenAt: __t.timestamp().name("last_seen_at"),
  createdAt: __t.timestamp().name("created_at"),
  sourceRoots: __t.string().name("source_roots"),
  updateRequested: __t.bool().name("update_requested"),
  updateError: __t.string().name("update_error"),
});
